<template>
  <div class="page-compact">
    <crm-panel :title="'合同列表'">
      <div class="page-buttons">
        <crm-button
          v-if="contractAuth.addContract && contractAuth.addContract.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="addCompactDialogVisible = true"
        >
        </crm-button>
        <crm-button
          v-if="contractAuth.exportContract && contractAuth.exportContract.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <el-select
              placeholder="合同类型"
              clearable
              v-model="searchForm.contractType"
              @visible-change="handleGetCategoryData('compactType')"
            >
              <el-option
                v-for="item in compactType"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              placeholder="签约形式"
              clearable
              v-model="searchForm.signingForm"
              @visible-change="handleGetCategoryData('signingForm')"
            >
              <el-option
                v-for="item in signingForm"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="crmAuth.categoryTeamType !== '4'">
            <el-cascader
              ref="cascader"
              :options="allProductLine"
              :props="{
                value: 'id',
                label: 'name',
                children: 'productLineList',
                multiple: true,
              }"
              clearable
              placeholder="请选择产品线"
              collapse-tags
              v-model="searchForm.businessLineArr"
            >
            </el-cascader>
            <!-- <el-select
              placeholder="产品线"
              clearable
              v-model="searchForm.businessLine"
              @visible-change="handleGetCategoryData('busiLine')"
            >
              <el-option
                :key="item.uid"
                v-for="item in busiLineList"
                :label="item.name"
                :value="item.uid"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="" v-if="crmAuth.categoryTeamType !== '4'">
            <el-select
              placeholder="结算方式"
              clearable
              v-model="searchForm.settlementType"
              @visible-change="handleGetCategoryData('settlementType')"
            >
              <el-option
                v-for="item in settlementType"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <crm-cascader
              :value="searchForm.teamIds"
              :options="visitTeamList"
              placeholder="团队"
              clearable
              :props="{ multiple: true, checkStrictly: true }"
              :show-all-levels="false"
              @change="changeParentTeam"
            >
            </crm-cascader>
          </el-form-item>
          <el-form-item label="">
            <div class="select-data-picker">
              <el-select v-model="searchDateType">
                <el-option label="合同日期" :value="1"></el-option>
                <el-option label="签订日期" :value="2"></el-option>
                <el-option label="创建日期" :value="3"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="searchTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-input
              :placeholder="`根据${searchNamePlaceholder[searchNameType]}查询`"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <we-search-input-type-options v-once />
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 合同列表 -->
      <el-table
        :data="compactData && compactData.results"
        height="100%"
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          label="合同编号"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCompactDetailShow(scope)">{{
              scope.row.contractNo
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          width="150"
          label="客户名称"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCustomClick(scope)">{{
              scope.row.customerName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="contractTypeName"
          width="120"
          align="center"
          label="合同类型"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="crmAuth.categoryTeamType !== '4'"
          prop="businessLineName"
          align="center"
          label="产品线"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="coopModeName"
          align="center"
          width="130"
          label="合作模式"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.coopModeName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="crmAuth.categoryTeamType === '4'"
          width="150"
          prop="departmentNames"
          align="center"
          label="合作科室"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.departmentNames.join("，") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="contractAmount"
          width="130"
          align="center"
          label="合同金额(元)"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="refundAmount"
          width="130"
          align="center"
          label="回款金额(元)"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCompactDetailShow(scope, 'returnRecord')">{{
              scope.row.refundAmount
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="receivableAmount"
          width="130"
          align="center"
          label="应收金额(元)"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="crmAuth.categoryTeamType !== '4'"
          prop="costAmount"
          width="100"
          align="center"
          label="成本(元)"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCompactDetailShow(scope, 'cost')">{{
              scope.row.costAmount
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="crmAuth.categoryTeamType !== '4'"
          prop="settlementName"
          width="120"
          align="center"
          label="结算方式"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="signDate"
          width="100"
          align="center"
          label="签订日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="startDate"
          width="100"
          align="center"
          label="开始日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="endDate"
          width="100"
          align="center"
          label="结束日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="userName"
          align="center"
          label="业务员"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="fileCount"
          align="center"
          label="附件"
        >
        </el-table-column>
        <el-table-column fixed="right" width="100" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="
                contractAuth.updateContract && contractAuth.updateContract.toggleStatus
              "
              @click="handleUpdate(scope)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="
                contractAuth.deleteContract && contractAuth.deleteContract.toggleStatus
              "
              @click="handleDelete(scope)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 合同列表分页 -->
      <div class="pageination">
        <!-- <div class="info-wrap">
          <span class="info-title">合同总金额：</span>
            <span class="info-detail">{{compactCount.contractAmountCount}}</span>
            <span class="info-title">合同总数：</span>
            <span class="info-detail">{{compactCount.contractCount}}</span>
            <span class="info-title">回款总金额：</span>
            <span class="info-detail">{{compactCount.refundAmountCount}}</span>
            <span class="info-title">应收总金额：</span>
            <span class="info-detail">{{compactCount.receivableAmountCount}}</span>
        </div> -->
        <div class="info-wrap">
          <p>
            <span class="info-title">合同总金额：</span>
            <span class="info-detail">{{ compactCount.contractAmountCount }}</span>
            <span class="info-title">合同总数：</span>
            <span class="info-detail">{{ compactCount.contractCount }}</span>
          </p>
          <p>
            <span class="info-title">回款总金额：</span>
            <span class="info-detail">{{ compactCount.refundAmountCount }}</span>
            <span class="info-title">应收总金额：</span>
            <span class="info-detail">{{ compactCount.receivableAmountCount }}</span>
          </p>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next"
          :total="(compactData && compactData.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新增合同弹窗 -->
    <add-compact
      v-if="addCompactDialogVisible"
      @close="addCompactDialogVisible = false"
      @success="handleRefreshCompact()"
    >
    </add-compact>

    <!-- 编辑合同弹窗 -->
    <update-compact
      v-if="updateCompactDialogVisible"
      :id="compactId"
      :contractType="contractType"
      @close="updateCompactDialogVisible = false"
      @success="handleRefreshCompact()"
    >
    </update-compact>

    <!-- 合同详情侧面板 -->
    <transition name="slide-fade">
      <div v-show="compactDetailVisible">
        <compact-detail
          :row="row"
          :detailId="detailId"
          :detailTabName="detailTabName"
          @handleCloseDetail="handleCloseCompactDetail"
        >
        </compact-detail>
      </div>
    </transition>

    <!-- 客户详情侧面板 -->
    <we-custom-details
      v-if="customDetailShow"
      v-bind="viewPanel"
      :sourcePart="'customer'"
      @closeCustomDetail="closeCustomDetail"
      @saveEditCustom="handleSearch"
      @success="handleRefreshCompact()"
    >
    </we-custom-details>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import config from "~config";
import { newDownloadByUrl, isEmptyObj } from "@/scripts/utils";
import AddCompact from "~component/business/compact/AddCompact.vue";
import UpdateCompact from "~component/business/compact/UpdateCompact.vue";
import CompactDetail from "~component/business/compact/detail.vue";
import WeSearchInputTypeOptions from "~component/business/compact/search-input-type-options";
import WeCustomDetails from "~component/business/custom/customDetails.vue";
import crmPanel from "@/components/base/crmPanel";
import crmButton from "@/components/base/crmButton";
import AddEditDialog from "@/components/base/addEditDialog";
import CrmCascader from "@/components/base/crmCascader";
import api from "@/services/api/compact/index.js";
import service from "@/services/api/common";

export default {
  provide() {
    return { info: this.info };
  },
  components: {
    AddCompact,
    UpdateCompact,
    CompactDetail,
    WeSearchInputTypeOptions,
    WeCustomDetails,
    crmPanel,
    crmButton,
    AddEditDialog,
    CrmCascader,
  },
  data() {
    return {
      row: {},
      loading: false,
      searchName: "",
      searchTime: [],
      searchDateType: 1,
      searchNameType: "customerName",
      // 搜索表单
      searchDate: {
        contractStartDate: null,
        contractEndDate: null,
        createdStartDate: null,
        createdEndDate: null,
        signStartDate: null,
        signEndDate: null,
      },
      searchForm: {
        contractType: "",
        signingForm: "",
        businessLine: [],
        businessLineArr: [],
        teamIds: null,
        settlementType: null,
        departmentId: null,
        customerName: null,
        salesmanName: null,
        contractNo: null,
        remarks: null,
      },
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      isExportDisabled: false,
      // 合同详情
      detailTabName: null,
      detailId: "",
      compactDetailVisible: false,
      // 查看客户详情
      customDetailShow: false,
      // 客户查看面板
      customRow: {},
      viewPanel: {
        uid: "",
        type: 1,
        teamId: 1,
        authEdit: true,
        authDelete: true,
      },
      addCompactDialogVisible: false,
      updateCompactDialogVisible: false,
      compactId: "",
      contractType: "",
      contractNumber: null,
      contractAmount: null,
      // 新版产品线
      allProductLine: [],
      searchNamePlaceholder: {
        remarks: '备注',
        salesmanName: '业务员',
        contractNo: '合同编号',
        customerNo: '客户编号',
        customerName: '客户名称',
      },
    };
  },
  computed: {
    ...mapGetters({
      contractAuth: "authority/contractAuth",
      customAuth: "authority/customAuth",
      compactTeams: "compact/compactTeams",
      busiLineList: "business/busiLineList",
      compactType: "compact/compactType",
      settlementType: "compact/settlementType",
      coprationDepartment: "compact/coprationDepartment",
      compactData: "compact/compactData",
      compactCount: "compact/compactCount",
      compactDetail: "compact/compactDetail",
      crmAuth: "common/crmAuth",
      signingForm: "compact/signingForm",
      userInfo: "authority/userInfo",
      customDetail: "customer/customDetail",
    }),
    visitTeamList() {
      let teamArr = [];
      teamArr = JSON.parse(JSON.stringify([this.compactTeams]));
      this.deleteEmptyChild(teamArr);
      return teamArr;
    },
  },
  watch: {
    "searchForm.contractType": {
      handler: "handleSearch",
    },
    "searchForm.settlementType": {
      handler: "handleSearch",
    },
    "searchForm.signingForm": {
      handler: "handleSearch",
    },
    "searchForm.businessLineArr": {
      handler: "handleSearch",
    },
    "searchForm.teamIds": {
      handler: "handleSearch",
    },
    searchTime: {
      handler: "handleSearch",
    },
    searchDateType: {
      handler: "handleSearch",
    },
  },
  created() {
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.searchDateType = this.$route.params.searchDateType
        ? this.$route.params.searchDateType
        : 1;
      this.searchTime = this.$route.params.searchTime
        ? this.$route.params.searchTime
        : [];
    }
    // 获取团队
    this.getCompactTeams();
    // this.handleSearch();
    // 更新新版产品线下拉
    this.getAllProductLine();
    this.searchForm.teamIds = [this.userInfo.teamId];

    if (Object.keys(this.customAuth).length === 0)
      this.getAuthority({ menuUrl: "/customer/valid" });
  },
  methods: {
    ...mapActions({
      getAuthority: "authority/getAuthority",
      getCompactTeams: "compact/getCompactTeams",
      getCompactTypeList: "compact/getCompactTypeList",
      getBusiLineList: "business/getBusiLineList",
      getSettlementTypeList: "compact/getSettlementTypeList",
      getCoprationDepartmentList: "compact/getCoprationDepartmentList",
      getCompactList: "compact/getCompactList",
      getCompactCount: "compact/getCompactCount",
      deleteCompact: "compact/deleteCompact",
      getCompactDetail: "compact/getCompactDetail",
      compactExport: "compact/compactExport",
      getSigningFormList: "compact/getSigningFormList",
      getCustomDetail: "customer/getCustomDetail",
    }),
    getAllProductLine() {
      console.log(service, "service");
      service.queryProductLineListForSearch().then((res) => {
        res.data.data.forEach((item) => {
          this.allProductLine.push({
            ...item,
            id: item.typeCode,
            name: item.typeName,
          });
        });
      });
    },
    handleGetCategoryData(type) {
      // 获取合同类型
      if (type === "compactType") {
        if (this.compactType.length === 0) {
          this.getCompactTypeList({
            pageNumber: this.pagenation.pageNumber,
            pageSize: this.pagenation.pageSize,
            code: "category_contract_type",
          });
        }
      } else if (type === "busiLine") {
        // 获取产品线
        // if (this.busiLineList.length === 0) {
        //   this.getBusiLineList({
        //     pageNumber: this.pagenation.pageNumber,
        //     pageSize: this.pagenation.pageSize,
        //     code: 'category_business_line',
        //   });
        // }
        // 更新新版产品线下拉
        this.getAllProductLine();
      } else if (type === "settlementType") {
        // 获取结算方式
        if (this.settlementType.length === 0) {
          this.getSettlementTypeList({
            pageNumber: this.pagenation.pageNumber,
            pageSize: this.pagenation.pageSize,
            code: "category_settlement_type",
          });
        }
      } else if (type === "category_department") {
        // 获取合作科室
        if (this.coprationDepartment.length === 0) {
          this.getCoprationDepartmentList({
            pageNumber: this.pagenation.pageNumber,
            pageSize: this.pagenation.pageSize,
            code: "category_department",
          });
        }
      } else if (type === "signingForm") {
        // 获取签约形式
        if (this.signingForm.length === 0) {
          this.getSigningFormList({
            pageNumber: this.pagenation.pageNumber,
            pageSize: this.pagenation.pageSize,
            code: "category_signing_form",
          });
        }
      }
    },
    // 团队级联选择器删除空子联机
    deleteEmptyChild(arr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length <= 0) {
          delete item.children;
        } else {
          this.deleteEmptyChild(item.children);
        }
      });
    },
    changeParentTeam(teamInfo) {
      if (teamInfo.type && teamInfo.type === "multiple") {
        this.searchForm.teamIds = teamInfo.value;
      } else {
        this.searchForm.teamIds = teamInfo[teamInfo.length - 1];
      }
    },
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      this.handleSearchData();
      const { businessLineArr, businessLine, ...otherParams } = this.searchForm;
      const params = {
        ...this.pagenation,
        ...otherParams,
        businessLine: businessLineArr.map(it => it.length >= 2 ? it[1] : '').filter(ele => !!ele),
        ...this.searchDate,
      };

      const url = `${config.api || ""}/api/crmcontract/download`;

      newDownloadByUrl(url, "post", params).finally(() => {
        this.isExportDisabled = false;
        this.notify.close();
      });
    },
    // 合同详情
    handleCompactDetailShow(scope, tabName) {
      this.row = scope.row;
      this.detailId = scope.row.id;
      this.contractNumber = scope.row.contractNo;
      this.contractAmount = scope.row.contractAmount;
      this.compactDetailVisible = true;
      if (tabName) {
        this.detailTabName = tabName;
      } else {
        this.detailTabName = null;
      }
    },
    handleCloseCompactDetail(isRefresh) {
      this.compactDetailVisible = false;
      if (isRefresh) {
        this.handleGetCompactList();
        this.handleGetCompactCount();
      }
    },
    // 搜索按钮
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetCompactList();
      this.handleGetCompactCount();
    },
    // 根据条件刷新合同列表
    handleGetCompactList() {
      this.loading = true;
      this.handleSearchData();
      const { businessLineArr, businessLine, ...otherParams } = this.searchForm;
      this.getCompactList({
        ...this.pagenation,
        ...otherParams,
        businessLine: businessLineArr.map(it => it.length >= 2 ? it[1] : '').filter(ele => !!ele),        ...this.searchDate,
        $_priority: 10,
      }).finally(() => {
        this.loading = false;
      });
    },
    // 获取合同统计数据
    handleGetCompactCount() {
      this.handleSearchData();
      const { businessLineArr, businessLine, ...otherParams } = this.searchForm;
      return this.getCompactCount({
        ...otherParams,
        ...this.searchDate,
        businessLine: businessLineArr.map(it => it.length >= 2 ? it[1] : '').filter(ele => !!ele),
        $_priority: 10,
      });
    },
    // 处理搜索数据
    handleSearchData() {
      this.searchDate = {
        contractStartDate: null,
        contractEndDate: null,
        createdStartDate: null,
        createdEndDate: null,
        signStartDate: null,
        signEndDate: null,
      };
      const dateList = ["contract", "sign", "created"];
      if (this.searchTime && this.searchTime.length > 0) {
        this.searchDate[
          `${dateList[this.searchDateType - 1]}StartDate`
        ] = this.searchTime[0];
        this.searchDate[
          `${dateList[this.searchDateType - 1]}EndDate`
        ] = this.searchTime[1];
      }

      const nameList = [
        "customerName",
        "customerNo",
        "contractNo",
        "salesmanName",
        "remarks",
      ];
      nameList.forEach((i) => {
        this.searchForm[i] = null;
      });
      if (this.searchName) this.searchForm[this.searchNameType] = this.searchName;
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetCompactList(this.pagenation);
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetCompactList(this.pagenation);
    },
    // 编辑
    handleUpdate(scope) {
      this.compactId = scope.row.id;
      this.contractType = scope.row.contractType;
      this.updateCompactDialogVisible = true;
    },
    handleRefreshCompact() {
      this.handleGetCompactList();
      this.handleGetCompactCount();
    },
    // 删除合同
    handleDelete(scope) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCompact({ id: scope.row.id }).then(() => {
            this.handleGetCompactList();
            this.handleGetCompactCount();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {});
    },
    // 客户详情
    async handleCustomClick(scope) {
      if (scope.row.customerIsDeleted === 1) {
        this.$message({
          type: "error",
          message: "该客户不存在或已删除",
        });
      } else {
        await this.getCustomDetail({
          sourcePart: "customer",
          uid: scope.row.customerId,
        }).then(() => {
          if (!isEmptyObj(this.customDetail)) {
            this.customRow = scope.row;
            this.customDetailShow = true;
            this.viewPanel = Object.assign(this.viewPanel, {
              uid: scope.row.customerId,
              type: scope.row.customerType,
              teamId: scope.row.teamId,
              authEdit:
                !scope.row.searchUid && this.customAuth.customerUpdate.toggleStatus,
              authDelete: this.customAuth.customerDelete.toggleStatus,
            });
          }
        });
      }
    },
    closeCustomDetail() {
      this.customDetailShow = false;
      this.handleGetCompactList();
      this.handleGetCompactCount();
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/const.less";

.page-compact {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .el-checkbox {
    color: rgba(0, 0, 0, 0);
  }
}
</style>
